import './cta-divider.scss';